import { render, staticRenderFns } from "./PolicyGroup.vue?vue&type=template&id=fe7d7fb4"
import script from "./PolicyGroup.vue?vue&type=script&lang=js"
export * from "./PolicyGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports